module.exports = __webpack_public_path__ + "img/NXT-alt.586fcbe6.svg";